import * as React from 'react';
import {  Box, Grid, Typography } from '@mui/material';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
// import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
// import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
// import AddTaskIcon from '@mui/icons-material/AddTask';
// import ReceiptIcon from '@mui/icons-material/Receipt';
// import Avatar from '@mui/material/Avatar';

// const avatarStyle = {
//   width: '30px',
//   height: '30px',
//   bgcolor: '#c8e6c9',
// };
export default function BasicCard() {
  return (
  <div> 
    <Box>
      <Grid container spacing={1}>
        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <Card sx={{ height:'45px',width:'250px', borderRadius:'10px', bgcolor:'#f1f8e9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)' }}>
            <CardContent>
            <Box  display= "flex" justifyContent= "space-between">
              <Typography>
                Expecting 
              </Typography>
              <Typography variant='h5'>
                1
              </Typography>
              {/* <Avatar sx={avatarStyle}><WorkHistoryIcon sx={{color:'#66bb6a'}} /></Avatar> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <Card sx={{ height:'45px',width:'250px', borderRadius:'10px',bgcolor:'#f1f8e9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)' }}>
            <CardContent>
            <Box  display= "flex" justifyContent= "space-between">
              <Typography>
                Completed          
              </Typography>
              <Typography variant='h5'>
                1
              </Typography>
              {/* <Avatar sx={avatarStyle}><AddTaskIcon sx={{color:'#66bb6a'}} /></Avatar> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <Card sx={{ height:'45px',width:'250px', borderRadius:'10px', bgcolor:'#f1f8e9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)' }}>
            <CardContent>
            <Box  display= "flex" justifyContent= "space-between" >
              <Typography >
                In Progress  
              </Typography>
              <Typography variant='h5'>
                1
              </Typography>
              {/* <Avatar sx={avatarStyle}><PublishedWithChangesIcon sx={{color:'#66bb6a'}} /></Avatar> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={6} display="flex" justifyContent="flex-end">
          <Card sx={{ height:'45px',width:'250px', borderRadius:'10px',bgcolor:'#f1f8e9', boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.3)' }}>
            <CardContent >
              <Box  display= "flex" justifyContent= "space-between">
              <Typography >
                Invoiced   
              </Typography>
              <Typography variant='h5'>
                2
              </Typography>
              {/* <Avatar sx={avatarStyle}><ReceiptIcon sx={{color:'#66bb6a'}} /></Avatar> */}
              </Box>
            </CardContent>
          </Card>
        </Grid>
    </Grid>
    </Box>
  </div>
  );
}
